import { createContext, useContext, useState, PropsWithChildren } from 'react';

type AiAgentContextValue = {
  isOpen: boolean;
  isMinimized: boolean;
  open: () => void;
  close: () => void;
  minimize: () => void;
  pendingNotification: string | null;
  pushNotification: (message: string) => void;
  clearNotification: () => void;
};

const AiAgentContext = createContext<AiAgentContextValue | null>(null);

export const AiAgentProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [pendingNotification, setPendingNotification] = useState<string | null>(
    null,
  );

  return (
    <AiAgentContext.Provider
      value={{
        isOpen,
        isMinimized,
        open: () => {
          setIsOpen(true);
          setIsMinimized(false);
        },
        close: () => setIsOpen(false),
        minimize: () => setIsMinimized(true),
        pendingNotification,
        pushNotification: (message) => setPendingNotification(message),
        clearNotification: () => setPendingNotification(null),
      }}
    >
      {children}
    </AiAgentContext.Provider>
  );
};

export const useAiAgent = (): AiAgentContextValue => {
  const ctx = useContext(AiAgentContext);
  if (!ctx) throw new Error('useAiAgent must be used within AiAgentProvider');
  return ctx;
};
